export enum TagType {
    User = 1,
    Desk = 2,
    Room = 3,
    Location = 4,
    Site = 5
}

export type Tag = {
    Id: number;
    Type: TagType;
    Label: string;
    Tooltip: string;
}